import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getUUID } from 'utils/utils';

interface Props {
    open: "barrier" | "kpi" | null
    type: "edit" | "creation" | "view" | null
    action_id: number | null // used to fetch action details on action edit
    audit_id: number | null // used to fetch action details on action edit
    barriers: string[] | null
    is_pse_barrier?: boolean | null

}

const initialState: Props = {
    open: null,
    type: null,
    action_id: null,
    audit_id: null,
    barriers: null,
    is_pse_barrier: null
};

const modalStateSlice = createSlice({
    name: 'ActionTrackerModalState',
    initialState,
    reducers: {
        setActionTrackerPopupState: (state, action: PayloadAction<Props>) => {
            Object.assign(state, action.payload);
        },

    },
});

export const { setActionTrackerPopupState } = modalStateSlice.actions;
export default modalStateSlice.reducer;
